import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal, faCodeBranch, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Hackathons.scss';

const wins = [
  { title: "PW × AWS Hackathon", role: "Winner", org: "Organized by PW & AWS" },
  { title: "Peerhub Hackathon", role: "Winner", org: "IIT Roorkee" },
  { title: "Aya Hackathon", role: "Winner", org: "IIIT Bangalore" },
  { title: "AWS × POI Hackathon", role: "Winner", org: "Organized by AWS" },
  { title: "Pine Labs Hackathon", role: "Winner", org: "Pine Labs Plural" },
  { title: "NASA Space Apps 2024", role: "Top Local Finalist", org: "NASA Space Apps Community" }
];

const finalists = [
  { title: "Great Bengaluru Hackathon", role: "Top 9 Finalist", org: "Bangalore" },
  { title: "i-Hack AWS", role: "Finalist", org: "IIT Bombay" },
  { title: "IIT Ropar Hackathon", role: "Finalist", org: "IIT Ropar" },
  { title: "IIT Madras Hackathon", role: "Finalist", org: "IIT Madras" },
  { title: "GFG Vultr Hackathon", role: "Top 10 Winner", org: "GeeksforGeeks & Vultr" },
  { title: "IEEESOC 2025", role: "5th Place", org: "BMSIT" }
];

const openSource = [
  { title: "GSSoC / GSoC 2026", role: "Contributor", org: "PRs to Metaflow, Kubeflow, Gemini CLI" },
  { title: "GitHub Badges", role: "Earned Badges", org: "Pull Shark ×2, Pair Extraordinaire, YOLO, Quickdraw" }
];

function Hackathons() {
  return (
    <div className="container" id="hackathons">
      <div className="items-container">
        <h1>Achievements & Leadership</h1>
        
        <div style={{ marginTop: '20px' }}>
          <h2><FontAwesomeIcon icon={faTrophy} style={{ color: '#ffd700', marginRight: '10px' }} /> 10× Hackathon Wins</h2>
          <div className="hackathons-grid" style={{ marginBottom: '40px' }}>
            {wins.map((hack, index) => (
              <div className="hack-card" key={index}>
                <div className="icon-wrapper">
                  <FontAwesomeIcon icon={faTrophy} size="2x" />
                </div>
                <div className="hack-info">
                  <h3>{hack.title}</h3>
                  <p className="achievement">{hack.role}</p>
                  <p className="organizer">{hack.org}</p>
                </div>
              </div>
            ))}
          </div>

          <h2><FontAwesomeIcon icon={faMedal} style={{ color: '#c0c0c0', marginRight: '10px' }} /> Top Placements & Finalists</h2>
          <div className="hackathons-grid" style={{ marginBottom: '40px' }}>
            {finalists.map((hack, index) => (
              <div className="hack-card" key={index}>
                <div className="icon-wrapper">
                  <FontAwesomeIcon icon={faMedal} size="2x" />
                </div>
                <div className="hack-info">
                  <h3>{hack.title}</h3>
                  <p className="achievement" style={{ color: '#c0c0c0' }}>{hack.role}</p>
                  <p className="organizer">{hack.org}</p>
                </div>
              </div>
            ))}
          </div>

          <h2><FontAwesomeIcon icon={faCodeBranch} style={{ color: '#5000ca', marginRight: '10px' }} /> Open Source & Badges</h2>
          <div className="hackathons-grid">
            {openSource.map((hack, index) => (
              <div className="hack-card" key={index}>
                <div className="icon-wrapper">
                  <FontAwesomeIcon icon={index === 0 ? faCodeBranch : faShieldHalved} size="2x" />
                </div>
                <div className="hack-info">
                  <h3>{hack.title}</h3>
                  <p className="achievement" style={{ color: '#8a2be2' }}>{hack.role}</p>
                  <p className="organizer">{hack.org}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default Hackathons;
